/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/close-white': {
    width: 22,
    height: 22,
    viewBox: '0 0 22 22',
    data: '<path pid="0" _fill="#fff" d="M0 2.2L2.2 0 22 19.8 19.8 22z"/><path pid="1" _fill="#fff" d="M19.8 0L22 2.2 2.2 22 0 19.8z"/>'
  }
})
